var common = require("../../../utiles/common.js");
var service = require("../../../utiles/service");

module.exports = {
  register: function () {
    document.createElement("manage-auth");
    ko.components.register("manage-auth", {
      viewModel: function (params) {
        var ids = location.hash.replace("#/manageAuth/", "").split("/");
        var $this = this;
        $this.addItem = ko.observable(false);
        $this.isDisable = ko.observable(false);
        $this.items = ko.observableArray();
        $this.item = ko.observable("");
        $this.userId = ko.observable("");
        $this.getList = function () {
          var items = service.auth.list(ids[0], ids[1]).result;
          $this.items(items ? items : []);
          $this.addItem(false);
        };
        $this.updateItem = function () {
          $this.addItem(false);
          $this.isDisable(false);
          $this.item(this);
          $this.addItem(true);
          $this.isDisable(true);
        };
        $this.removeItem = function () {
          var id = this.app.id;
          console.log($this.items());
          service.auth.remove({ delegateId: id });
          $this.getList();
        };
        $this.toggleClose = function (id) {
          $this.userId("");
          $this.userId(id);
        };
        $this.getList();
        $this.close = function () {
          common.redirectTo("/#/appConfig/" + ids[2]);
        };
      },
      template: require("./ManageAuth.html"),
    });
    document.createElement("auth-item");
    ko.components.register("auth-item", {
      viewModel: function (params) {
        var $this = this;
        $this.app = params.app;
        console.log($this.app);
        $this.update = params.update;
        $this.remove = params.remove;
        $this.toggleClose = params.toggleClose;
        $this.userId = params.userId;
        $this.isenable = ko.observable("");
        if (!!$this.app.endDate && !!$this.app.startDate) {
          $this.isenable(
            common.timestampToTime($this.app.startDate) +
             "\t"+ "--" +"\t"+
              common.timestampToTime($this.app.endDate) +
              "\t"+"生效"
          );
        } else {
          if (!!$this.app.startDate) {
            $this.isenable(
              common.timestampToTime($this.app.startDate) + "开始生效"
            );
          } else if (!!$this.app.endDate) {
            $this.isenable(
              common.timestampToTime($this.app.endDate) + "后失效"
            );
          } else {
            $this.isenable("长期有效");
          }
        }
      },
      template: require("./auth/AuthItem.html"),
    });
    document.createElement("add-auth");
    ko.components.register("add-auth", {
      viewModel: function (params) {
        var ids = location.hash.replace("#/manageAuth/", "").split("/");
        var $this = this;
        var pageIndex = 1;
        $this.isViold = ko.observable(false);
        $this.isData = ko.observable(false);
        $this.isUpdate = ko.observable(false);
        $this.userId = ko.observable("");
        $this.dats = ko.observableArray([]);
        $this.get = params.get;
        $this.displayName = ko.observable("");
        $this.validMsg = ko.observable("");
        $this.isUpdate(params.isDisable());
        if (params.item() != "") {
          $this.displayName(params.item().app.assigneeSubject?params.item().app.assigneeSubject.code:"");
          $("#startTime").val(
            common.timestampToTime(params.item().app.startDate)
          );
          $("#endTime").val(common.timestampToTime(params.item().app.endDate));
          $this.userId(params.item().app.assigneeSubject?params.item().app.assigneeSubject._id:undefined);
        }
        console.log($this.isUpdate());
        laydate.render({
          elem: "#startTime",
          type: "datetime",
        });
        laydate.render({
          elem: "#endTime",
          type: "datetime",
        });
        $this.selectList = function (event) {
          $this.getList(1);
        };
        $this.getList = function (index) {
          pageIndex++;
          var sreach = {
            condName: $("#userName").val(),
            filters: [],
            order: "",
            pageNumber: index ? index : pageIndex,
            pageSize: 20,
          };
          $this.datas = service.auth.userSearch(sreach);
          $this.selectSubject($this.datas.result);
          if (index) {
            $this.dats($this.datas.result);
            $this.scrollBottomTest();
          } else {
            $this.dats($this.dats().concat($this.datas.result));
          }
          if ($this.dats().length > 0) {
            $this.isData(true);
          } else {
            $this.isData(false);
          }
        };
        $this.scrollBottomTest = function () {
          $("#contName").scroll(function () {
            var self = $(this),
              viewH = self.height(),
              contentH = self.get(0).scrollHeight,
              scrollTop = self.scrollTop();
            if (contentH - viewH - scrollTop <= 10) {
              $this.getList();
            }
          });
        };

        $this.selectSubject = function (params) {
          for (var i = 0; i < params.length; i++) {
            var orgName = params[i].orgName;
            var userName = params[i].userName;
            params[i].orgAndUser = orgName
              ? orgName + "/" + userName
              : userName;
          }
        };

        $this.activeItem = function (item) {
          console.log(item);
          $("#userName").val(item.userName);
          $this.userId(item.id);
          $this.isData(false);
          $this.isViold(false);
        };

        $this.addAuth = function () {
          var start = new Date($("#startTime").val());
          var end = new Date($("#endTime").val());
          if (start.getTime() > end.getTime()) {
            $this.validMsg("开始时间不能大于结束时间！");
            $this.isViold(true);
            return false;
          }
          if (this.userId() == "") {
            $this.validMsg("必须选择用户！");
            $this.isViold(true);
            return false;
          }
          var obj = {
            startDate: start.getTime(),
            endDate: end.getTime(),
            delegationType: "ACCOUNT_LINK",
            assignee: this.userId(),
            account: decodeURIComponent(ids[0]),
            appCode: ids[1],
          };
          console.log(obj);
          if (params.item() != "") {
            obj.delegateId = params.item().app.id;
            common.fetch("/auth/delegation/update", {
              type: "POST",
              data: JSON.stringify(obj),
              handleError: function (data) {
                //$this.errorMessage(data.message);
              },
              success: function (result) {
                $this.datas = result.data;
                $this.get();
                $("#userName").val("");
                $("#startTime").val("");
                $("#endTime").val("");
              },
            });
          } else {
            common.fetch("/auth/delegation/add", {
              type: "POST",
              data: JSON.stringify(obj),
              handleError: function (data) {
                //$this.errorMessage(data.message);
              },
              success: function (result) {
                $this.datas = result.data;
                $this.get();
              },
            });
          }
        };
      },
      template: require("./auth/AddAuth.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/template/ManageAuth.js
// module id = 154
// module chunks = 0